import { SERVER_ERROR, CLEAR_ERRORS } from "./types";

export const clearServerErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};

export const handleServerError = (dispatch, error) => {
  const errors = {};

  // Check if error.response exists (might be undefined for network errors, CORS issues, etc.)
  if (!error.response || !error.response.data) {
    // Network error or no response data
    errors["error"] = error.message || "Network error occurred";
    dispatch({
      type: SERVER_ERROR,
      payload: errors,
    });
    return;
  }

  const data = error.response.data;

  for (var key of Object.keys(data)) {
    if (Array.isArray(data[key])) {
      errors[key] = data[key][0];
    } else {
      errors["error"] = data[key];
    }
  }
  dispatch({
    type: SERVER_ERROR,
    payload: errors,
  });
};
